import { Component, ElementRef, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "custom-expansion-panel",
  templateUrl: "./custom-expansion-panel.component.html",
  styleUrls: ["./custom-expansion-panel.component.scss"]
})
export class CustomExpansionPanelComponent implements OnChanges {
  @Input() title: string | undefined;
  @Input() subtitle: string | undefined;
  @Input() theme: "primary" | "critical" | undefined;
  @Input() info: string | undefined;
  @Input() forceOpen: boolean | undefined;

  color: string = "#000011";

  panelOpenState: boolean | undefined;

  constructor(private host: ElementRef<any>) {}

  ngOnChanges(changes: SimpleChanges) {
    if ("theme" in changes) {
      this.color = this.theme === "primary" ? "#000011" : "#110000";
      this.host.nativeElement.style.setProperty(`--color`, this.color);
    }
  }
}
